import React, { useEffect } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectFilteredCustomers, selectCustomerLoading, selectfetchCustomerLoading } from './store/selectors';
import { showModal } from 'Core/redux/main/slice';
import { deleteCustomer } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { actions as customerActions } from './store/slice';

const { setProduct } = customerActions;

const { CUSTOMERS_ADD_EDIT } = MODAL_TYPES;

const CustomerTable = () => {
  const dispatch = useDispatch();
  const { filteredData, isLoading } = useSelector(state => ({
    filteredData: selectFilteredCustomers(state),
    isLoading: selectCustomerLoading(state) || selectfetchCustomerLoading(state),
  }));

  const handleEditClick = record => {
    dispatch(setProduct(record));
    dispatch(showModal(CUSTOMERS_ADD_EDIT, record));
  };

  const handleDeleteClick = id => {
    dispatch(deleteCustomer(id));
  };

  const handleCheckboxChange = (e, record) => {
    // Handle checkbox change logic here
    console.log('Checkbox changed', record, e.target.checked);
  };

  const columns = [
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
      sorter: (a, b) => a.customerName.length - b.customerName.length,
    },
    // {
    //   title: 'Customer Number',
    //   dataIndex: 'customerNumber',
    //   sorter: (a, b) => a.customerNumber.length - b.customerNumber.length,
    // },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: (a, b) => a.status.length - b.status.length,
      render: (text, record) => (
        <span
          style={{
            backgroundColor: record.backGroundColor,
            color: record.textColor,
            padding: '4px 8px',
            borderRadius: '4px',
          }}
        >
          {text}
        </span>
      ),
    },
    // {
    //   title: 'Customer External ID',
    //   dataIndex: 'customerIdExt',
    //   sorter: (a, b) => a.customerIdExt.length - b.customerIdExt.length,
    // },
    // {
    //   title: 'Customer ID',
    //   dataIndex: 'id',
    //   sorter: (a, b) => a.id.length - b.id.length,
    // },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action justify-content-start">
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            {/* <Link className="confirm-text p-2" onClick={() => handleDeleteClick(record.id)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link> */}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {isLoading && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default CustomerTable;
